import register from '@kpsys/angularjs-register';

import loginComponentModule from './kp-login/kp-login.module';

import LoginService from './login.service';
import MainLoginFormService from './main-login-form-service';
import RegistrationService from './registration.service';
import AuthPairingController from './auth-pairing.controller';

/**
 * @ngdoc module
 * @name portaro.login
 * @module portaro.login
 */

export default register('portaro.login', [loginComponentModule])
    .service(MainLoginFormService.serviceName, MainLoginFormService)
    .service(LoginService.serviceName, LoginService)
    .service(RegistrationService.serviceName, RegistrationService)
    .controller(AuthPairingController.controllerName, AuthPairingController)
    .name();
